export default {
  LOGIN: '/auth/developer/login',
  LOGOUT: '/auth/logout',
  USER: '/users',
  CHANGE_PASSWORD: '/auth/change-password',
  UPDATE_ACCOUNT: '/users/developers/me',
  API_KEY_LIST: 'home/applications/:id/app-keys',
  APPLICATION_LIST: '/applications',
  DB: '/face-dbs',
  CLUSTER_DB: '/face-dbs/:db',
  LOCATION_LIST: '/face-dbs/:db/locations',
  API_KEY: '/applications/:id/app-keys',
  SERVICE_LIST: '/applications/service',
  UPDATE_API_KEY: '/applications/:id/app-keys/:key',
  USER_ID_LIST: '/applications/:id/private-dbs/:dbId/private-id',
  USER_ID_DETAIL: '/applications/:appId/private-dbs/:dbId/private-id/:id',
};
